/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Price_AscInputs */

const en_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price ↑`)
};

const es_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio ↑`)
};

const fr_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix croissant`)
};

const de_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis ↑`)
};

const ja_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格の安い順`)
};

const zh_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格 ↑`)
};

const ar_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر ↑`)
};

const id_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ↑`)
};

const it_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo ↑`)
};

const ru_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала дешевые`)
};

const pt_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menor Preço`)
};

const ko_search_sort_price_asc = /** @type {(inputs: Search_Sort_Price_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`낮은 가격순`)
};

/**
* | output |
* | --- |
* | "Price ↑" |
*
* @param {Search_Sort_Price_AscInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_sort_price_asc = /** @type {((inputs?: Search_Sort_Price_AscInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Price_AscInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_sort_price_asc(inputs)
	if (locale === "es") return es_search_sort_price_asc(inputs)
	if (locale === "fr") return fr_search_sort_price_asc(inputs)
	if (locale === "de") return de_search_sort_price_asc(inputs)
	if (locale === "ja") return ja_search_sort_price_asc(inputs)
	if (locale === "zh") return zh_search_sort_price_asc(inputs)
	if (locale === "ar") return ar_search_sort_price_asc(inputs)
	if (locale === "id") return id_search_sort_price_asc(inputs)
	if (locale === "it") return it_search_sort_price_asc(inputs)
	if (locale === "ru") return ru_search_sort_price_asc(inputs)
	if (locale === "pt") return pt_search_sort_price_asc(inputs)
	return ko_search_sort_price_asc(inputs)
});